var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckmarkSm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 11,
  height: 9,
  viewBox: "0 0 11 9",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M1.8 3.277C.818 2.293-.66 3.769.326 4.753L3.153 8.39c.34.437.902.458 1.263.037 0 0 5.257-6.134 5.75-6.626C11.15.817 9.672-.66 8.688.325l-4.92 4.92z"
})));
export default SvgCheckmarkSm;